module.exports = __webpack_public_path__ + "img/GAME_CARDRIVE2.90075134.jpg";